import { Award, Lock } from "lucide-react";

export default function Achievements({ achievements }) {
  const list = achievements || [];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="academy-achievements">
      {list.map((a) => (
        <div key={a.code} data-testid={`academy-badge-${a.code}`} className={`border p-5 text-center ${a.earned ? "bg-[#121212] border-white/25" : "bg-[#0d0d0d] border-white/[0.06] opacity-55"}`}>
          <div className={`mx-auto mb-3 h-12 w-12 rounded-full flex items-center justify-center border ${a.earned ? "border-white bg-white/10" : "border-white/15"}`}>
            {a.earned ? <Award size={22} className="text-white" /> : <Lock size={18} className="text-white/30" />}
          </div>
          <p className="font-display font-bold uppercase tracking-tight text-sm leading-tight">{a.title}</p>
          <p className="text-white/40 text-[11px] mt-1 leading-snug">{a.description}</p>
          {a.earned && a.earned_at && <p className="font-mono-accent text-[9px] tracking-widest uppercase text-white/30 mt-2">{new Date(a.earned_at).toLocaleDateString()}</p>}
        </div>
      ))}
    </div>
  );
}
